import { WebViewerInstance } from '@pdftron/webviewer';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch, RootState } from '../../../../../service/drawings/src/ui';
import {
    NavigationCurrentSheetType,
    updateHistoryNavigation,
} from '../../../../../service/drawings/src/ui/store/drawings-slice';
import { WebViewerStateType } from '../../../../../service/drawings/src/ui/types/types';

export const useStateViewerAppryze = (webViewer: WebViewerInstance | null) => {
    const dispatch = useDispatch<AppDispatch>();
    const navigationCurrentSheet = useSelector<RootState, NavigationCurrentSheetType | undefined>(
        (state) => state.drawings?.navigationCurrentSheet,
    );
    const currentDrawingSetIdRef = useRef<string>('');

    useEffect(() => {
        currentDrawingSetIdRef.current = navigationCurrentSheet?.sheet.drawingSetId || '';
        if (!navigationCurrentSheet?.webViewerState.zoom) {
            return;
        }

        setTimeout(() => {
            restoreViewerState(webViewer!, {
                zoom: navigationCurrentSheet?.webViewerState.zoom,
                scrollLeft: navigationCurrentSheet?.webViewerState.scrollLeft,
                scrollTop: navigationCurrentSheet?.webViewerState.scrollTop,
            });
        }, 100);
    }, [navigationCurrentSheet]);

    const getCurrentViewerState = (instance: WebViewerInstance): WebViewerStateType => {
        const documentViewer = instance?.Core.documentViewer;
        const scrollElement = documentViewer?.getScrollViewElement();

        return {
            zoom: documentViewer?.getZoomLevel(),
            scrollLeft: scrollElement?.scrollLeft,
            scrollTop: scrollElement?.scrollTop,
        };
    };

    const restoreViewerState = (instance: WebViewerInstance, state: WebViewerStateType) => {
        if (!instance) return;

        const documentViewer = instance.Core.documentViewer;

        documentViewer.zoomTo(state.zoom!);

        setTimeout(() => {
            const scrollElement = documentViewer.getScrollViewElement();
            scrollElement.scrollLeft = state.scrollLeft!;
            scrollElement.scrollTop = state.scrollTop!;
        }, 100);
    };

    const setupStateListeners = (instance: WebViewerInstance) => {
        const documentViewer = instance.Core.documentViewer;
        const scrollElement = documentViewer.getScrollViewElement();

        const handleStateChange = () => {
            const state = getCurrentViewerState(instance);

            if (state.scrollLeft && state.scrollTop && state.scrollLeft > 1 && state.scrollTop > 1) {
                dispatch(
                    updateHistoryNavigation({ stateInstance: state, drawingSetId: currentDrawingSetIdRef.current! }),
                );
            }
        };

        documentViewer.addEventListener('zoomUpdated', handleStateChange);
        scrollElement.addEventListener('scroll', handleStateChange);

        return () => {
            documentViewer.removeEventListener('zoomUpdated', handleStateChange);
            scrollElement.removeEventListener('scroll', handleStateChange);
        };
    };

    return { setupStateListeners };
};
